import { GoogleAnalytics } from './google-analytics';
import { getBuilderAnalyticsContext } from './builder-analytics-context';

const sendToGoogleAnalytics = (feature, value, params = {}) => {
  const { isPrismBuilder, isBuilderGa4EventEnabled } =
    getBuilderAnalyticsContext();

  if (!isBuilderGa4EventEnabled) {
    return true;
  }

  const eventBuilder = isPrismBuilder ? 'Prism-Builder' : 'Prints-Builder';
  const product = isPrismBuilder ? wkData.product.type : '';

  new GoogleAnalytics().sendEvent(eventBuilder, {
    event_type: feature,
    event_value: value,
    event_product: product,
    event_category: 'FeatureTracking',
    cohort: '0',
    ...params,
  });

  return true;
};

export default sendToGoogleAnalytics;
